import React from 'react';
import IntegrationCloud from './IntegrationCloud';
import { useNavigate } from 'react-router-dom';

function IntegrationCloudPage() {
    const navigate = useNavigate();

    return (
        <div style={{ padding: '24px' }}>
            {/* Header */}
            <div className="d-flex align-items-center gap-3 mb-4">
                <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => navigate(-1)}
                    style={{ color: '#94A3B8', borderColor: '#334155' }}
                >
                    ← Back
                </button>
            </div>
            
            <IntegrationCloud wrapper={true} />
        </div>
    );
}

export default IntegrationCloudPage;
